/*
 *
 * FurnitureInfos
 *
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import {
  makeSelectCabinet,
  makeSelectFurniture,
  makeSelectSelectedIdCabinet,
} from 'containers/Configurator/selectors/furniture';
import Price from 'containers/FurnitureInfos/Price';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';
import properties from '../../helpers/config';
import SaveForLaterLink from '../SaveForLater/SaveForLaterLink';

interface StateProps {
  cabinet: Cabinet | null;
  furniture: Furniture | null;
  selectedCabinetId: string | null;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  cabinet: makeSelectCabinet(),
  furniture: makeSelectFurniture(),
  selectedCabinetId: makeSelectSelectedIdCabinet(),
});

function FurnitureInfos() {
  const { cabinet, furniture, selectedCabinetId } = useSelector(stateSelector);
  if (selectedCabinetId === null && furniture) {
    return (
      <div className="flex w-full justify-between">
        <Price
          amount={furniture?.displayPriceTaxInclude(
            properties.vat,
            properties.resellerRate,
            properties.decimalSeparator,
            properties.thousenSeparator,
          )}
        />
        <SaveForLaterLink />
      </div>
    );
  }
  if (cabinet) {
    return (
      <div className="flex flex-col md:flex-row items-center w-full justify-between">
        <Price
          amount={cabinet?.displayPriceTaxInclude(
            properties.vat,
            properties.resellerRate,
            properties.decimalSeparator,
            properties.thousenSeparator,
          )}
        />
        <SaveForLaterLink />
      </div>
    );
  }
  return null;
}

export default FurnitureInfos;
